import script from "./TopBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopBar.vue?vue&type=script&lang=ts&setup=true"

import "./TopBar.vue?vue&type=style&index=0&id=2ab6b461&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ab6b461"]])

export default __exports__